import FederationArchitecture from "../../../../shared/diagrams/federation-architecture.mdx";
import * as React from 'react';
export default {
  FederationArchitecture,
  React
};